<template>
    <div id="app">
        <button id="rtmp" @click="change(1)">RTMP</button>
        <button id="mp4" @click="change(2)">MP4</button>
        <button id="hls" @click="change(3)">HLS</button>
        <button @click="pause">pause</button>
        <button @click="play">play</button>
        <button @click="reset">reset</button>
        <button id="full" @click="setFullScreen">setFullScreen</button>
        <hrm-player
            :width="900"
            :height="500"
            :muted="true"
            :autoplay="true"
            :controls="true"
            ref="myPlayer"
            @init="aaa"
            :source="src"
            :type="type"
        />
    </div>
</template>
<script>
    import hrmPlayer from '../lib/index.common.js';
    import '../lib/index.css';
    export default {
        name: 'App',
        components: {
            hrmPlayer
        },
        data() {
            return {
                type: '',
                src: ''
            };
        },
        methods: {
            aaa(obj) {
                console.log('a', obj);
            },
            change(val) {
                console.log(val);
                switch (val) {
                    case 1:
                        this.src = 'http://211.79.36.141/iTV/segments/ch46/index.m3u8';
                        this.type = 'rtmp/flv';
                        break;
                    case 2:
                        this.src = 'http://www.w3school.com.cn/i/movie.mp4';
                        this.type = 'video/mp4';
                        break;
                    case 3:
                        this.src = 'http://playertest.longtailvideo.com/adaptive/bipbop/gear4/prog_index.m3u8';
                        this.type = 'application/x-mpegURL';
                        break;
                }
            },
            pause() {
                this.$refs.myPlayer.pause();
            },
            play() {
                this.$refs.myPlayer.play();
            },
            reset() {
                this.$refs.myPlayer.reset();
            },
            setFullScreen() {
                this.$refs.myPlayer.setFullScreen();
            }
        }
    };
</script>
